import React, { Button } from '@mui/material';
import { SubmitButtonEvent } from './SubmitButtonProps';

export const SubmitButton = ({ text }: SubmitButtonEvent) => {
	return (
		<Button color='primary' variant='contained' fullWidth type='submit'>
			{text}
		</Button>
	);
};
